export default __webpack_public_path__ + "static/media/slide5.57279cc8.svg";